const COOKIE_NAME = 'customer_vip'
const COOKIE_MAX_AGE = 604800 // 7 days
const CLOSE_DELAY = 1800

const SELECTORS = {
  trigger: '[data-product-lock-trigger]',
  close: '.product-lock-modal__close',
  submit: '.product-lock-modal__submit',
  input: '.product-lock-modal__input',
  error: '.product-lock-modal__error',
  success: '.product-lock-modal__success',
  formWrapper: '.product-lock-modal__form-wrapper',
}

const SETTINGS = window.productLockSettings || {}

const MODAL_HTML = `
  <div class="product-lock-modal__container">
    <button class="product-lock-modal__close" type="button" aria-label="Cerrar">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
        <line x1="18" y1="6" x2="6" y2="18"/>
        <line x1="6" y1="6" x2="18" y2="18"/>
      </svg>
    </button>
    <div class="product-lock-modal__icon">
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor">
        <path d="M12 2C9.24 2 7 4.24 7 7v3H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8a2 2 0 0 0-2-2h-1V7c0-2.76-2.24-5-5-5zm-3 5c0-1.65 1.35-3 3-3s3 1.35 3 3v3H9V7zm4 10.72V19h-2v-1.28a2 2 0 0 1-1-1.72 2 2 0 1 1 3 1.72z"/>
      </svg>
    </div>
    <h2 class="product-lock-modal__title">${SETTINGS.modalTitle || 'Contenido exclusivo'}</h2>
    <p class="product-lock-modal__text">${SETTINGS.modalText || 'Ingresá tu email para acceder al contenido exclusivo.'}</p>
    <div class="product-lock-modal__form-wrapper">
      <input class="product-lock-modal__input" type="email" placeholder="${SETTINGS.inputPlaceholder || 'Tu email'}" required autocomplete="email">
      <div class="product-lock-modal__error">${SETTINGS.errorText || 'Ocurrió un error. Intentá nuevamente.'}</div>
      <button class="product-lock-modal__submit" type="button">${SETTINGS.submitText || 'ACCEDER'}</button>
    </div>
    <p class="product-lock-modal__success">${SETTINGS.successText || 'Acceso desbloqueado exitosamente.'}</p>
  </div>
`

/* ----------------------------------------
   Cookie helpers
   ---------------------------------------- */

const hasVipCookie = () => document.cookie.includes(`${COOKIE_NAME}=true`)

const setVipCookie = () => {
  document.cookie = `${COOKIE_NAME}=true; path=/; max-age=${COOKIE_MAX_AGE}`
}

let formSubmitted = false
const isPdpLocked = document.body.hasAttribute('data-product-locked-page') && !hasVipCookie()

/* ----------------------------------------
   Modal
   ---------------------------------------- */

let modalEl = null

const getModal = () => {
  if (modalEl) return modalEl

  modalEl = document.createElement('div')
  modalEl.className = 'product-lock-modal'
  modalEl.innerHTML = MODAL_HTML
  document.body.appendChild(modalEl)

  bindModalEvents(modalEl)
  return modalEl
}

const openModal = () => {
  const modal = getModal()

  if (isPdpLocked) {
    modal.querySelector(SELECTORS.close).style.display = 'none'
  }

  /* Force reflow so the transition plays on first open */
  void modal.offsetHeight
  modal.classList.add('active')
  document.body.classList.add('overflow-hidden')
  modal.querySelector(SELECTORS.input)?.focus()

  if (!isPdpLocked) {
    document.addEventListener('keydown', handleEsc)
  }
}

const closeModal = () => {
  if (!modalEl) return
  if (isPdpLocked && !formSubmitted) return
  modalEl.classList.remove('active')
  document.body.classList.remove('overflow-hidden')
  document.removeEventListener('keydown', handleEsc)
}

const handleEsc = ({ key }) => {
  if (key === 'Escape') closeModal()
}

/* ----------------------------------------
   Form submit (AJAX)
   ---------------------------------------- */

const handleSubmit = async (modal) => {
  const emailInput = modal.querySelector(SELECTORS.input)
  const submitBtn = modal.querySelector(SELECTORS.submit)
  const errorEl = modal.querySelector(SELECTORS.error)
  const successEl = modal.querySelector(SELECTORS.success)
  const formWrapper = modal.querySelector(SELECTORS.formWrapper)

  emailInput.classList.remove('error')
  errorEl.classList.remove('visible')

  if (!emailInput.value || !emailInput.validity.valid) {
    emailInput.classList.add('error')
    return
  }

  submitBtn.disabled = true

  const body = new FormData()
  body.append('form_type', 'customer')
  body.append('utf8', '✓')
  body.append('contact[tags]', 'vip')
  body.append('contact[email]', emailInput.value)

  try {
    const response = await fetch('/contact', {
      method: 'POST',
      body,
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })

    if (!response.ok) throw new Error(response.status)

    setVipCookie()
    document.documentElement.classList.add('customer-vip')
    formSubmitted = true

    /* Restore neutralized URLs on locked cards */
    document.querySelectorAll('[data-locked-url]').forEach((card) => {
      const url = card.getAttribute('data-locked-url')
      card.querySelectorAll('a[href="#"]').forEach((link) => {
        link.href = url
      })
    })

    formWrapper.style.display = 'none'
    successEl.classList.add('visible')

    setTimeout(closeModal, CLOSE_DELAY)
  } catch {
    errorEl.classList.add('visible')
    emailInput.classList.add('error')
    submitBtn.disabled = false
  }
}

/* ----------------------------------------
   Event binding
   ---------------------------------------- */

const bindModalEvents = (modal) => {
  modal.querySelector(SELECTORS.close).addEventListener('click', closeModal)

  modal.addEventListener('click', ({ target }) => {
    if (target === modal) closeModal()
  })

  modal.querySelector(SELECTORS.submit).addEventListener('click', () => {
    handleSubmit(modal)
  })

  modal.querySelector(SELECTORS.input).addEventListener('keydown', ({ key }) => {
    if (key === 'Enter') handleSubmit(modal)
  })
}

/* ----------------------------------------
   Init
   ---------------------------------------- */

/* Cookie check — prevent blur flash */
if (hasVipCookie()) {
  document.documentElement.classList.add('customer-vip')
}

/* Event delegation for all CTA triggers */
document.addEventListener('click', (e) => {
  const trigger = e.target.closest(SELECTORS.trigger)
  if (!trigger) return

  e.preventDefault()
  e.stopPropagation()
  openModal()
})

/* Auto-open on PDP if product is locked and user is not VIP */
if (isPdpLocked) {
  openModal()
}

/* ----------------------------------------
   Anti-bypass (MutationObserver)
   ---------------------------------------- */

const initAntiBypass = () => {
  /* Protect locked cards on collection pages */
  document.querySelectorAll('[data-product-locked]').forEach((card) => {
    const overlay = card.querySelector('.product-lock-overlay')

    const cardObserver = new MutationObserver(() => {
      if (!card.classList.contains('card-wrapper--locked')) {
        card.classList.add('card-wrapper--locked')
      }
      if (overlay && !card.contains(overlay)) {
        card.insertBefore(overlay, card.firstChild)
      }
    })

    cardObserver.observe(card, {
      attributes: true,
      attributeFilter: ['class', 'style'],
      childList: true,
    })
  })

  /* Protect PDP modal */
  if (isPdpLocked) {
    const bodyObserver = new MutationObserver(() => {
      if (!formSubmitted && modalEl && !document.body.contains(modalEl)) {
        document.body.appendChild(modalEl)
        modalEl.classList.add('active')
      }
    })

    bodyObserver.observe(document.body, { childList: true })

    const htmlObserver = new MutationObserver(() => {
      if (!formSubmitted && document.documentElement.classList.contains('customer-vip')) {
        document.documentElement.classList.remove('customer-vip')
      }
    })

    htmlObserver.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['class'],
    })

    if (modalEl) {
      const modalObserver = new MutationObserver(() => {
        if (!formSubmitted) {
          if (!modalEl.classList.contains('active')) {
            modalEl.classList.add('active')
          }
          modalEl.removeAttribute('style')
        }
      })

      modalObserver.observe(modalEl, {
        attributes: true,
        attributeFilter: ['class', 'style'],
      })
    }

    /* Interval fallback — re-enforce even if observers are disconnected */
    setInterval(() => {
      if (formSubmitted) return
      if (!document.body.contains(modalEl)) {
        document.body.appendChild(modalEl)
      }
      if (!modalEl.classList.contains('active')) {
        modalEl.classList.add('active')
      }
      if (document.documentElement.classList.contains('customer-vip')) {
        document.documentElement.classList.remove('customer-vip')
      }
    }, 500)
  }
}

initAntiBypass()
